import { render, staticRenderFns } from "./loginDialog.vue?vue&type=template&id=27b65f31&scoped=true"
import script from "./loginDialog.vue?vue&type=script&lang=js"
export * from "./loginDialog.vue?vue&type=script&lang=js"
import style0 from "./loginDialog.vue?vue&type=style&index=0&id=27b65f31&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b65f31",
  null
  
)

export default component.exports